import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { getSprintData, getSprintDataById, addSprintData, updateSprintData, deleteSprintData, getSprintReportData } from '../../helpers/';
import { getSprintResponseSuccess, getSprintResponseError } from './actions';
import { SprintActionTypes } from './constants';

/**
 * 
 * Get List Issue Type
 * @param {*} payload
 * @query
 * 
 */

function* sprintData({ payload }) {
    try {
        const response = yield call(getSprintData, payload.params);
        yield put(getSprintResponseSuccess(SprintActionTypes.GET_SPRINT_DATA, response.data));
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.GET_SPRINT_DATA, error));
    };
};

function* sprintDataById({ payload }) {
    try {
        const response = yield call(getSprintDataById, payload);
        yield put(getSprintResponseSuccess(SprintActionTypes.GET_SPRINT_BY_ID, response.data))
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.GET_SPRINT_BY_ID, error))
    }
};

function* addSprint({ payload }) {
    try {
        const response = yield call(addSprintData, payload);
        yield put(getSprintResponseSuccess(SprintActionTypes.ADD_SPRINT_DATA, response.data));
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.ADD_SPRINT_DATA, error));
    }
};

function* updateSprint({ payload }) {
    try {
        const response = yield call(updateSprintData, payload);
        yield put(getSprintResponseSuccess(SprintActionTypes.UPDATE_SPRINT_DATA, response.data));
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.UPDATE_SPRINT_DATA, error))
    }
};

function* deleteSprint({ payload }) {
    try {
        const response = yield call(deleteSprintData, payload);
        yield put(getSprintResponseSuccess(SprintActionTypes.DELETE_SPRINT_DATA, response.data));
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.DELETE_SPRINT_DATA, error))
    }
};

function* getSprintReport({ payload }) {
    try {
        const response = yield call(getSprintReportData, payload);
        yield put(getSprintResponseSuccess(SprintActionTypes.GET_SPRINT_REPORT_DATA, response.data));
    } catch(error) {
        yield put(getSprintResponseError(SprintActionTypes.GET_SPRINT_REPORT_DATA, error));
    }
}

export function* watchSprintData() {
    yield takeEvery(SprintActionTypes.GET_SPRINT_DATA, sprintData)
};

export function* watchSprintDataById() {
    yield takeEvery(SprintActionTypes.GET_SPRINT_BY_ID, sprintDataById);
};

export function* watchAddSprintData() {
    yield takeEvery(SprintActionTypes.ADD_SPRINT_DATA, addSprint);
};

export function* watchUpdateSprintData() {
    yield takeEvery(SprintActionTypes.UPDATE_SPRINT_DATA, updateSprint);
};

export function* watchDeleteSprintData() {
    yield takeEvery(SprintActionTypes.DELETE_SPRINT_DATA, deleteSprint);
};

export function* watchSprintReportData() {
    yield takeEvery(SprintActionTypes.GET_SPRINT_REPORT_DATA, getSprintReport);
}

function* sprintSaga() {
    yield all([
        fork(watchSprintData),
        fork(watchSprintDataById),
        fork(watchAddSprintData),
        fork(watchUpdateSprintData),
        fork(watchDeleteSprintData),
        fork(watchSprintReportData),
    ])
};

export default sprintSaga;  